import React, { useState } from "react";
import styled from "styled-components";
import { FaEnvelope, FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import api from "../services/api";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/CAJ.png";

/* CONTAINER */
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffff;
  font-family: "Segoe UI", sans-serif;
`;

/* CARD */
const Card = styled.div`
  width: 100%;
  max-width: 350px;
  background: white;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 600px) {
    height: 100vh;
    justify-content: center;
  }
`;

/* LOGO */
const LogoImg = styled.img`
  width: 250px;
  margin-bottom: 10px;
`;

/* TITLE */
const Title = styled.h2`
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 25px;
  color: #262626;
`;

/* FORM */
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

/* INPUT BOX */
const InputBox = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #dbdbdb;
  padding: 12px;
  border-radius: 6px;
  background: #fafafa;

  svg {
    color: #8e8e8e;
  }
`;

/* INPUT */
const Input = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #262626;
  margin-left: 10px;

  /* REMOVE AUTOFILL AZUL */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0px 1000px #fafafa inset !important;
    box-shadow: 0 0 0px 1000px #fafafa inset !important;
    -webkit-text-fill-color: #262626 !important;
    transition: background-color 9999s ease-in-out 0s;
  }
`;

/* BOTÃO OLHO */
const EyeButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  margin-left: 10px;

  svg {
    color: #8e8e8e;
  }
`;

/* BUTTON */
const Button = styled.button`
  margin-top: 10px;
  padding: 12px;
  border: none;
  border-radius: 6px;
  background: #0095f6;
  color: white;
  font-weight: bold;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background: #0077cc;
  }
`;

/* FOOTER */
const Footer = styled.div`
  margin-top: 25px;
  font-size: 12px;
  color: #8e8e8e;
  text-align: center;
`;

export default function Login() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [showSenha, setShowSenha] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await api.post("/auth/login", { email, senha });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("usuario", JSON.stringify(res.data.usuario));

      toast.success("Login realizado com sucesso 🚀");

      navigate("/dashboard");
    } catch (err) {
      toast.info(
        err.response?.data?.message || "Erro ao fazer login"
      );
    }
  };

  return (
    <Container>
      <Card>

        <LogoImg src={Logo} alt="logo" />

        <Title>Entrar no sistema</Title>

        <Form onSubmit={handleLogin}>
          <InputBox>
            <FaEnvelope />
            <Input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </InputBox>

          <InputBox>
            <Input
              type={showSenha ? "text" : "password"}
              placeholder="Senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />

            <EyeButton
              type="button"
              onClick={() => setShowSenha(!showSenha)}
            >
              {showSenha ? <FaEyeSlash /> : <FaEye />}
            </EyeButton>
          </InputBox>

          <Button type="submit">Entrar</Button>
        </Form>

        <Footer>
          © Desenvolvido por Álvaro T. Branco
        </Footer>
      </Card>
    </Container>
  );
}